import React from 'react';
import { FadeIn } from './FadeIn';
export function PainSection() {
  return <section className="w-full py-24 px-6 bg-white relative" data-id="element-71">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-72">
        <FadeIn data-id="element-73">
          <div className="bg-creme rounded-3xl p-8 md:p-16 shadow-soft border border-beige relative overflow-hidden" data-id="element-74">
            {/* Decorative quote mark */}
            <div className="absolute top-4 left-6 text-9xl font-playfair text-beige opacity-50 leading-none select-none" data-id="element-75">
              "
            </div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-76">
              <p className="font-playfair text-2xl md:text-3xl lg:text-4xl text-dark-coffee leading-relaxed text-center italic mb-10" data-id="element-77">
                Domingo, 20:00 hs. Él no quiere comer. Tiene miedo. Y vos sentís
                que lo estás mandando a la guerra sin armas.
              </p>

              <div className="w-24 h-[1px] bg-warm-accent/30 mb-10" data-id="element-78"></div>

              <p className="text-center text-warm-accent font-bold text-2xl md:text-3xl tracking-wide uppercase" data-id="element-79">
                No aguantes más su dolor.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}